/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdrawnotdue3Inputs */

const en_dropdrawnotdue3 = /** @type {(inputs: Dropdrawnotdue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The draw unlocks at the draw date`)
};

const de_dropdrawnotdue3 = /** @type {(inputs: Dropdrawnotdue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ziehung wird zum Ziehungszeitpunkt freigeschaltet`)
};

/**
* | output |
* | --- |
* | "The draw unlocks at the draw date" |
*
* @param {Dropdrawnotdue3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdrawnotdue3 = /** @type {((inputs?: Dropdrawnotdue3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdrawnotdue3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdrawnotdue3(inputs)
	return de_dropdrawnotdue3(inputs)
});
export { dropdrawnotdue3 as "dropDrawNotDue" }